var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Image, StackView, Card, Button, Typography, Spacer, Spinner } from '@telus-uds/components-web';
import styled from 'styled-components';
import { space } from '../../helpers/theme';
var BUTTON_VARIATIONS = {
    PRIMARY: 'primary',
    LINK: 'link'
};
var getBtnVariantAttrs = function (variant) {
    switch (variant) {
        case BUTTON_VARIATIONS.LINK:
            return {
                text: true,
                priority: 'high'
            };
        default:
            return {
                text: false
            };
    }
};
export var InPageError = function (props) {
    var _a = props.border, border = _a === void 0 ? false : _a, imageSrc = props.imageSrc, _b = props.imageTokens, imageTokens = _b === void 0 ? {} : _b, heading = props.heading, children = props.children, _c = props.btnPrimaryLabel, btnPrimaryLabel = _c === void 0 ? undefined : _c, _d = props.btnPrimaryVariant, btnPrimaryVariant = _d === void 0 ? BUTTON_VARIATIONS.PRIMARY : _d, _e = props.btnSecondaryLabel, btnSecondaryLabel = _e === void 0 ? undefined : _e, _f = props.btnSecondaryVariant, btnSecondaryVariant = _f === void 0 ? BUTTON_VARIATIONS.LINK : _f, btnPrimaryOnClick = props.btnPrimaryOnClick, btnSecondaryOnClick = props.btnSecondaryOnClick, footer = props.footer, isPrimaryBtnLoading = props.isPrimaryBtnLoading;
    var hasButtons = !!btnPrimaryLabel || !!btnSecondaryLabel;
    var cardTokens = {
        borderWidth: border ? 1 : 0,
        paddingLeft: space(4),
        paddingRight: space(4),
        paddingTop: space(4),
        paddingBottom: space(4)
    };
    var Buttons = (_jsxs(_Fragment, { children: [btnPrimaryLabel && btnPrimaryOnClick && (_jsx(Spinner, { inline: true, variant: { size: 'small' }, show: isPrimaryBtnLoading, children: _jsx(Button, { onPress: btnPrimaryOnClick, variant: __assign({ width: 'responsive' }, getBtnVariantAttrs(btnPrimaryVariant)), children: btnPrimaryLabel }) })), btnSecondaryLabel && btnSecondaryOnClick && (_jsx(Button, { onPress: function () { return btnSecondaryOnClick(); }, disabled: isPrimaryBtnLoading, variant: __assign({ text: true, priority: 'high', width: 'responsive' }, getBtnVariantAttrs(btnSecondaryVariant)), children: btnSecondaryLabel }))] }));
    return (_jsx(Card, { tokens: cardTokens, variant: { padding: 'custom' }, children: _jsxs(StackView, { space: 5, tokens: { alignItems: 'center' }, children: [_jsx("div", { style: imageTokens, children: _jsx(Image, { src: imageSrc, alt: "", width: 150 }) }), _jsxs(StyledBody, { children: [heading && (_jsx(Typography, { block: true, variant: { size: 'h6' }, heading: "h6", children: heading })), children, hasButtons && (_jsxs(_Fragment, { children: [_jsx(Spacer, { size: 2 }), _jsx(StackView, { space: 3, tokens: { alignItems: 'center' }, children: Buttons })] }))] }), footer] }) }));
};
// --------------------------- STYLES --------------------------- //
var StyledBody = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & * {\n    align-items: center;\n    text-align: center;\n  }\n"], ["\n  & * {\n    align-items: center;\n    text-align: center;\n  }\n"])));
var templateObject_1;
